import logo from './logo.svg';
import './App.css';
import Home from '../src/screens/Home';
import Header from '../src/components/Header';
import Footer from '../src/components/Footer';
import AppRoutes  from '../src/routes/web';

function App() {
  return (
    <>
      <AppRoutes />
    </>
  )
}

export default App;
